import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { makeStyles, tokens, Spinner, Text } from "@fluentui/react-components";
import { useAuth } from "../hooks";

const useStyles = makeStyles({
  loadingContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100vh",
    gap: tokens.spacingVerticalM,
  },
});

export const RequireAuth: React.FC = () => {
  const styles = useStyles();
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className={styles.loadingContainer}>
        <Spinner size="large" />
        <Text>Loading...</Text>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};
